import axios from "axios/index";

/**
 *
 * @param params
 * @returns {Promise<any | {code: number, message: string}>}
 */
export const getList = params => axios.post('/business/deviceFrame/list', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
export const detail = params => axios.post('/business/deviceFrame/detail', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
export const create = params => axios.post('/business/deviceFrame/create', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
export const update = params => axios.post('/business/deviceFrame/update', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
export const exportTemplate = () => axios.post('/business/deviceFrame/exportTemplate', null, {
    responseType: 'blob',
    timeout: 20000
}).then(res => res ? res.data : {
    code: 500,
    msg: '服务器无法连接,请稍后重试',
});
export const importFile = formData => axios.post('/business/deviceFrame/importFile', formData).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});

